import React, { useEffect } from "react";
import { OnboardingApplication } from "@dreambigger/shared/src/types";
import { setAdminApplication } from "./adminApplicationStore";

interface AdminApplicationWrapperProps {
  children: React.ReactNode;
  application: OnboardingApplication;
  financialInstitutionId: string;
}

// Re-export the store helpers from this file so existing imports
// (`from "./AdminApplicationWrapper"`) keep working. The actual store +
// non-React getters live in `./adminApplicationStore` so jest and other
// non-React callers (like the display-condition evaluator) can import
// them without dragging this JSX file into their transform graph.
export {
  getAdminApplication,
  getAdminFinancialInstitutionId,
  isInAdminMode,
} from "./adminApplicationStore";

export const AdminApplicationWrapper: React.FC<AdminApplicationWrapperProps> =
  ({ children, application, financialInstitutionId }) => {
    useEffect(() => {
      setAdminApplication(application, financialInstitutionId);
      return () => {
        setAdminApplication(null, null);
      };
    }, [application, financialInstitutionId]);

    return <>{children}</>;
  };
